
import translator from './translator.json';
let es={},pt={},en={};


const translatorObject = {...translator};
const keys = Object.keys(translatorObject);

keys.forEach((key)=>{
  es[key]= translatorObject[key]['es'];
  pt[key]= translatorObject[key]['pt'];
  en[key]= translatorObject[key]['en'];
})

export const dictionaryList = { es, en, pt };

export const languageOptions = {
  es: 'Español (ES) ',
  pt: 'Português (PT) ',
  en: 'English (EN) '
};

